export default {
  title: "Mitt arbete",
  subtitle: "Mitt liv på jobbet",
  description: "En stor del av dagens vakna timmar är du på jobbet. Då är det viktigt att trivas och må bra.",
  startButton: "Sätt igång",
  results: "Resultat",
  goodJob: "Bra jobbat, se resultatet!",
  clickPieSlice: "Klicka på en tårtbit för att se mer information om ditt resultat.",
  healthyMessage: "Du är på rätt väg för att må bra i framtiden. Bygg vidare på det!",
  riskMessage: "Se upp för kommande ohälsa.",
  
  // Work factor labels (database labels - kept in Swedish)
  factorLabels: {
    'Arbetsmiljö': 'Arbetsmiljö',
    'Meningsfullhet': 'Meningsfullhet',
    'Trivsel': 'Trivsel',
    'Arbetsuppgifter': 'Arbetsuppgifter',
    'Förståelighet': 'Förståelighet',
    'Hanterbarhet': 'Hanterbarhet',
    'Kompetens': 'Kompetens',
    'Inflytande': 'Inflytande',
    'Stress på arbete': 'Stress på arbete',
    'Samarbete': 'Samarbete',
    'Ambitioner': 'Ambitioner',
    'Uppskattad': 'Uppskattad',
    'Samarbete chef': 'Samarbete chef',
    'Utveckling': 'Utveckling',
    'Mål (arbetsorganisation)': 'Mål (arbetsorganisation)',
    'Trygghet (säkerhet och hälsa)': 'Trygghet (säkerhet och hälsa)',
    'Lugn arbetsmiljö': 'Lugn arbetsmiljö',
    'Begriplighet': 'Begriplighet',
    'Trygghet': 'Trygghet',
    'Mål': 'Mål',
  },
  // Add any other work-related translations that might be needed
}; 